import { LimitObjType } from 'shared/types/swr-pagination-interface'

export const limitObj_10_25_50: LimitObjType = { short: 10, medium: 25, long: 50 }

export const limitObj_12_24_48: LimitObjType = { short: 12, medium: 24, long: 48 }
